import { __decorate } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { BrMaskerModule } from 'br-mask';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';

let UiCPixDevolutionFormComponent = class UiCPixDevolutionFormComponent {
    constructor() {
        this.onChangeForm = new EventEmitter();
        this.checkValue = new EventEmitter();
    }
    ngOnInit() { }
    changeFormHandler(value) {
        /* this.onChangeForm.emit(value) */
    }
    checkValueHandler(value) {
        this.checkValue.emit(value);
    }
    selectedDevolution(event) {
        this.onChangeForm.emit(event);
    }
};
__decorate([
    Input()
], UiCPixDevolutionFormComponent.prototype, "devolutionForm", void 0);
__decorate([
    Input()
], UiCPixDevolutionFormComponent.prototype, "errorMessages", void 0);
__decorate([
    Input()
], UiCPixDevolutionFormComponent.prototype, "listDevolutionReason", void 0);
__decorate([
    Output()
], UiCPixDevolutionFormComponent.prototype, "onChangeForm", void 0);
__decorate([
    Output()
], UiCPixDevolutionFormComponent.prototype, "checkValue", void 0);
UiCPixDevolutionFormComponent = __decorate([
    Component({
        selector: 'ui-c-pix-devolution-form',
        template: "<form class=\"ui-c-pix-devolution-form\" [formGroup]=\"devolutionForm\" (change)=\"changeFormHandler($event)\">\n  <div class=\"details\">\n    <ion-row>\n      <ion-col>\n        <div class=\"detail-item\">\n          <ion-item>\n            <ion-label position=\"stacked\">{{\n              'PIX.PIX_DEVOLUTION.FORM.DEVOLUTION_VALUE.LABEL' | wlpTranslate\n            }}</ion-label>\n            <ion-input\n              class=\"currency\"\n              type=\"tel\"\n              formControlName=\"devolutionValue\"\n              (keyup)=\"checkValueHandler($event.target.value)\"\n              [brmasker]=\"{ money: true, thousand: '.', decimalCaracter: ',', decimal: '2' }\"\n              maxlength=\"13\"\n              [placeholder]=\"'PIX.PIX_DEVOLUTION.FORM.DEVOLUTION_VALUE.PLACEHOLDER' | wlpTranslate\"\n            >\n              <span slot=\"start\" style=\"margin-right: 5px\">R$</span>\n            </ion-input>\n          </ion-item>\n          <div class=\"error-messages\">\n            <ng-container *ngFor=\"let error of errorMessages.devolutionValue\">\n              <div\n                class=\"error-message\"\n                *ngIf=\"\n                  devolutionForm.get('devolutionValue').hasError(error.type) &&\n                  (devolutionForm.get('devolutionValue').dirty || devolutionForm.get('devolutionValue').touched)\n                \"\n              >\n                {{ error.message | wlpTranslate: error?.param }}\n              </div>\n            </ng-container>\n          </div>\n        </div>\n      </ion-col>\n    </ion-row>\n    <ion-row>\n      <ion-col size=\"12\">\n        <div class=\"detail-item\">\n          <ion-list>\n            <ion-item>\n              <ion-label position=\"stacked\">{{\n                'PIX.PIX_DEVOLUTION.FORM.DEVOLUTION_REASON.LABEL' | wlpTranslate\n              }}</ion-label>\n              <ion-select\n                interface=\"action-sheet\"\n                formControlName=\"devolutionReason\"\n                cancelText=\"Cancelar\"\n                (ionChange)=\"selectedDevolution($event)\"\n                placeholder=\"Motivo da devolu\u00E7\u00E3o\"\n              >\n                <ion-select-option *ngFor=\"let devolutionReason of listDevolutionReason\" [value]=\"devolutionReason\"\n                  >{{ devolutionReason.name }}\n                </ion-select-option>\n              </ion-select>\n            </ion-item>\n          </ion-list>\n          <div class=\"error-messages\">\n            <ng-container *ngFor=\"let error of errorMessages.devolutionReason\">\n              <div\n                class=\"error-message\"\n                *ngIf=\"\n                  devolutionForm.get('devolutionReason').hasError(error.type) &&\n                  (devolutionForm.get('devolutionReason').dirty || devolutionForm.get('devolutionReason').touched)\n                \"\n              >\n                {{ error.message | wlpTranslate: error?.param }}\n              </div>\n            </ng-container>\n          </div>\n        </div>\n      </ion-col>\n    </ion-row>\n  </div>\n</form>\n"
    })
], UiCPixDevolutionFormComponent);

let UiCPixDevolutionFormModule = class UiCPixDevolutionFormModule {
};
UiCPixDevolutionFormModule = __decorate([
    NgModule({
        declarations: [UiCPixDevolutionFormComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            IonicModule,
            NgxMaskIonicModule,
            TooltipModule,
            BrMaskerModule,
            UiBsTranslateModule,
        ],
        exports: [UiCPixDevolutionFormComponent],
    })
], UiCPixDevolutionFormModule);

/*
 * Public API Surface of ui-c-pix-devolution-form
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCPixDevolutionFormComponent, UiCPixDevolutionFormModule };
//# sourceMappingURL=wlp-ui-c-pix-devolution-form.js.map
